<template>
  <div>
    <Modal
      :loading="loading"
      v-model="showModel"
      :width="750"
      :title="title"
      @on-ok="save"
      :footer-hide="disabled"
      @on-cancel="closeModel">
      <div class="form-area">
        <Form :disabled="disabled" style="width: 750px"
              :model="model"
              :label-width="140"
              label-position="right"
              :rules='rules'
              ref="form"
              inline>
          <FormItem :class="{'model-hidden': true}" label="文本框">
            <Input v-model="model.id" type="text"></Input>
          </FormItem>
          <Row>
            <Col span="12">
              <FormItem label="贷款产品名称:" prop="productName">
                <Input v-model="model.productName" style="width:200px" type="text"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="担保方式:" prop="guaranteeWay">
                <Select v-model="model.guaranteeWay" style="width:150px" clearable>
                  <Option v-for="(value,key) of guaranteeWay" :value="key" :key="key">{{ value }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="7">
              <FormItem label="利率范围:" prop="minRate">
                <Input v-model="model.minRate" style="width:100px" type="text"/>
              </FormItem>
            </Col>
            <Col span="5">
              <FormItem label="-" :label-width="35">
                <Input v-model="model.maxRate" style="width:100px" type="text"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="贷款期限:" prop="timeLimit">
                <Select v-model="model.timeLimit" style="width:150px" clearable>
                  <Option v-for="(value,key) of timeLimit" :value="key" :key="key">{{ value }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <FormItem label="贷款额度(万元):" prop="amount">
                <Input @on-keyup="model.amount = model.amount.replace(/[^\d.]/g,'')" v-model="model.amount" style="width:200px" type="text"/>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="产品类别:" prop="type">
                <Select v-model="model.type" style="width:150px" clearable>
                  <Option v-for="(value,key) of type" :value="key" :key="key">{{ value }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <FormItem label="项目详情:" prop="detail">
              <Input v-model="model.detail" style="width:510px" type="textarea"/>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="适用对象:" prop="target">
              <Input v-model="model.target" style="width:510px" type="text"/>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="产品活动时间:" prop="actTimeLimit">
              <RadioGroup v-model="model.actTimeLimit" @on-change=radioChange>
                <Radio label="1" key="1">{{'无限制'}}</Radio>
                <Radio label="2" key="2">{{'有限制'}}</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem v-if="model.actTimeLimit === '2'"
                      label="" prop="chooseDate">
              <DatePicker v-model="model.chooseDate"
                          @on-clear = clearDate
                          type="daterange"
                          format="yyyy-MM-dd"
                          placement="bottom-end"
                          style="width: 200px;margin-left: -80px"
                          size="small"/>
            </FormItem>
          </Row>
        </Form>
      </div>
    </Modal>
  </div>
</template>

<script>
import util from '@/libs/util.js';

export default {
  name: 'editItem',

  props:{
    title : {
      type: String,
      required: true
    },
    guaranteeWay:{
      type: Object
    },
    timeLimit:{
      type: Object
    },
    type:{
      type: Object
    },
  },
  data() {
    return {
      uploadUrl: util.baseUrl + "api/common/upload",
      //ID
      id: null,
      loading: true,
      showModel: false,
      //表单参数
      model: {
        id: null,
        bankId:null,
        productName:null,
        guaranteeWay:null,
        minRate:null,
        maxRate:null,
        timeLimit:null,
        amount:null,
        type:null,
        detail:null,
        target:null,
        actTimeLimit:'1',
        startTime:null,
        endTime:null,
        chooseDate:[],
        rowDate:[],
      },
      rules: {
        productName: [{required: true, message: '贷款产品名称', trigger: 'blur'}],
        guaranteeWay: [{required: true, message: '担保方式', trigger: 'change'}],
        minRate: [{required: true, message: '利率范围', trigger: 'blur'}],
        timeLimit: [{required: true, message: '贷款期限', trigger: 'change'}],
        amount: [{required: true, message: '贷款额度', trigger: 'blur'}],
        type: [{required: true, message: '产品类别', trigger: 'change'}],
        detail: [{required: true, message: '项目详情', trigger: 'blur'},
            { max: 1000, message: '不能超过1000字', trigger: 'blur' }],
        target: [{required: true, message: '适用对象', trigger: 'blur'}],
        actTimeLimit: [{required: true, message: '产品活动时间', trigger: 'change'}],
        chooseDate:[{type:'array',required: true,message: '产品活动时间',
          fields:{
            0:{type:'date',required: true, message: '产品活动时间',trigger: 'change'},
            1:{type:'date',required: true, message: '产品活动时间',trigger: 'change'}
          }
        }]
      },
      disabled: false,
      headers: {
        Authorization: localStorage.token,
      },
    };
  },
  mounted() {
  },
  methods: {
    save(){
      console.log(this.model)
      let _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          if (_this.model.chooseDate){
            _this.model.startTime = _this.model.chooseDate[0]
            _this.model.endTime = _this.model.chooseDate[1]
          }

          util.http.post("/api/bank/product/save", _this.model)
            .then(function (response){
              if(response.data.code === 200){
                _this.$Notice.success({
                  title: '保存成功!'
                });
                _this.$parent.handleOk()
                _this.closeModel()
              }else {
                _this.$Notice.success({
                  title: response.data.message
                });
                _this.loding = false;
                _this.$nextTick(() => {
                  _this.loading = true;
                });
              }
            })
        } else {
          _this.loading = false;
          _this.$nextTick(() => {
            _this.loading = true;
          });
        }
      })
    },

    radioChange(){
      if (this.model.actTimeLimit === 1){
        this.model.chooseDate = []
      }else {
        this.model.chooseDate = this.model.rowDate
      }
    },
    clearDate(){
      this.model.chooseDate = []
    },

    openModel() {
      this.$refs.form.resetFields()
      this.showModel = true
    },
    closeModel() {
      this.model = {
        id: null,
        bankId:null,
        productName:null,
        guaranteeWay:null,
        minRate:null,
        maxRate:null,
        timeLimit:null,
        amount:null,
        type:null,
        detail:null,
        target:null,
        actTimeLimit:'1',
        startTime:null,
        endTime:null,
        chooseDate:[],
        rowDate:[],
      }
      this.$refs.form.resetFields()
      this.loading = true
      this.showModel = false
    },

  }
};
</script>

<style scoped>
.button-area {
  display: flex;
  justify-content: flex-end;
}

.button-right-left {
  margin-right: 15px;
}

.button-right {
  margin-right: 55px;
}

.form-area {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.form-flex {
  display: flex;
  justify-content: space-between;
}

.model-hidden {
  display: none;
}

.ivu-modal {
  width: 1000px;
}

</style>
